<template>
  <div class="videojs-wrap">
    <video
      ref="videoPlayer"
      class="video-js"
      playsInline
      muted
      :autoplay="autoplay"
      :options="options"
    ></video>
  </div>
</template>

<script>
import videojs from "@/vendor/videojs/video.es.js";
import "@/videojs/HiShared.js";
import "@/videojs/HiZoom.js";
import "@/videojs/HiRecorder.js";
import "@/videojs/HiAutozoom.js";
import "@/videojs/HiMarkers.js";
import "@/videojs/HiMusic.js";
import "@/videojs/HiThumbnailGrabber.js";
import "@/vendor/videojs/video-js.css";

export default {
  name: "VideoJS",
  props: {
    autoplay: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      videoJSPlayer: null
    };
  },
  mounted() {
    this.videoJSPlayer = videojs(this.$refs.videoPlayer, this.options);

    this.videoJSPlayer.on("play", () => {
      this.$emit("playing");
    });

    this.videoJSPlayer.on("pause", () => {
      this.$emit("paused");
    });

    this.videoJSPlayer.on("seeked", () => {
      this.$emit("seeked");
    });

    this.videoJSPlayer.on("seeking", () => {
      this.$emit("seeking");
    });

    this.$emit("ready");
  },
  watch: {
    options: function(newvalue, oldvalue) {
      if (this.options && this.options.sources[0].type !== "application/vnd.videojs.vhs+json") {
        this.videoJSPlayer.src({
          src: this.options.sources[0].src,
          type: this.options.sources.type
        });
      } else {
        this.videoJSPlayer.src({
          src: this.options.sources[0].src,
          type: "application/vnd.videojs.vhs+json"
        });
      }
    }
  },
  beforeDestroy() {
    if (this.videoJSPlayer) {
      this.videoJSPlayer.dispose();
    }
  }
};
</script>

<style lang="stylus">
.videojs-wrap
  width: 100%;
  padding-top: 56.25%;
  position: relative;
  .video-js, .video-wrapper
    width: 100%
    height: 100%
    position: absolute;
    top: 0px;
    left: 0px;
    video
      pointer-events: none
  .video-wrapper
    .vjs-tech
      will-change: width, height
.zoomed
  cursor: grab;
.vjs-remaining-time-display
  font-family: "Hind"
.vjs-control-bar
  background: none!important
  &:before
    content: "";
    width: 100%
    height: 40px
    position: absolute
    bottom: 0px
    left: 0px
    background: linear-gradient(to bottom, rgba(18,24,68,0) 0%, #001249 99%, #001249 100%)
  .vjs-play-progress
    background: none!important
    &::before
      color: #EF4F23
  .vjs-time-tooltip
    display: none!important
  .vjs-mouse-display
    .vjs-time-tooltip
      display: block!important
      font-family: "hind"
      font-size: 16px
      transition: all 250ms
      .game-event-text
        width: 120px
        display: block
      &.game-event-hover
        .timestamp
          display: none;
  .vjs-marker
    width: 6px
    height: 6px
    position: absolute
    z-index: 10
    &:before
      content: "\f111"
      font-family: "VideoJS"
      font-size: 8px
      position: absolute
      right: 2px
      top: -2.3px
      color: rgba(255,255,255,0.5);
      z-index: 1
      transition: all 250ms
  .vjs-marker.pz-marker
    &:before
      content: ""
      width: 8px
      height: 8px
      background: #FFFFFF
    &.selected
      &:before
        background: #EF4F23
  &:hover
    .vjs-marker
      &:before
        top: -1.5px
        color: rgba(255,255,255,0.5);
      &:hover
        &:before
          color: rgba(255,255,255,1);
</style>
